// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--33Xyg","heading":"styles-module--heading--2uZea","mediaWrapper":"styles-module--mediaWrapper--2rJw2"};